export default function encryptValue(value) {
  const cryptoJs = require('crypto-js'); // eslint-disable-line
  const tokenInput = document.querySelector('input[name="_token"]');
  const token = tokenInput.value;

  return cryptoJs.AES.encrypt(value, token).toString();
}
